/* istanbul ignore file */
import React from 'react';
import { CreateButton } from 'framework/ui/ui-builder';
import { useVacancyGroupId, useVacancyGroupUrl } from '../../../../routing';

const CreateVacancyPublicationButton = () => {
  const groupId = useVacancyGroupId();
  const { getCreatePublicationUrl } = useVacancyGroupUrl();

  return <CreateButton url={getCreatePublicationUrl(groupId)} label="Add platform" key="create-publication" />;
};

export default CreateVacancyPublicationButton;
